/**
 * @internal Used only by EventContext. Do not import directly from pages/components.
 * Use `useEventContext()` from `@/contexts/EventContext` instead.
 *
 * Thin localStorage helper for persisting the selected event ID across sessions.
 * Guards against storage being unavailable (private/incognito mode) by wrapping
 * all access in try/catch; failures are treated as no-op / null.
 */

const SELECTED_EVENT_ID_KEY = 'iplan.web.selectedEventId';

export const eventStorage = {
  getSelectedEventId(): string | null {
    if (typeof window === 'undefined') return null;
    try {
      return localStorage.getItem(SELECTED_EVENT_ID_KEY);
    } catch {
      return null;
    }
  },

  setSelectedEventId(id: string | null): void {
    if (typeof window === 'undefined') return;
    try {
      if (id === null) {
        localStorage.removeItem(SELECTED_EVENT_ID_KEY);
      } else {
        localStorage.setItem(SELECTED_EVENT_ID_KEY, id);
      }
    } catch {
      // Storage unavailable — treat as no-op.
    }
  },
};
